/**
 * Nav Primary and Nav Sub
 */


(function ($) {

    // set variables
    var navPrimary = '.js-nav-primary'
        navLink = 'a[href^="#"]',
        navPrimaryLink = navPrimary + ' ' + navLink,
        activeClass = 'is-active',
        isCurrent = '.is-current',
        hideIndicatorClass = 'hide-indicator',
        $navPrimaryLink = $(navPrimaryLink + ':not(' + activeClass + ')'),
        $navSubLayer = $('.js-nav-sub__layer');


    $(navPrimaryLink).on('click',function (e) {

        var $this = $(this);
        var target = this.hash;
        var $target = $(target);

        // when target exists
        if ($target.length) {

            e.preventDefault();

            // click on non active nav link
            if (!$(this).parent().hasClass(activeClass)) {

                // add this nav item active class
                $this.parent().addClass(activeClass);

                // add nav sub layer active class
                $target.addClass(activeClass);

                // remove active class from nav sub layer siblings
                $target.siblings().removeClass(activeClass);

                // remove active class from other nav items
                $this.parent().siblings().removeClass(activeClass);

                // hide indicator from current nav item
                $this.parent().siblings(isCurrent).addClass(hideIndicatorClass);

            }

            // click on active nav link
            else {

                // remove this nav item active class
                $this.parent().removeClass(activeClass);

                // remove nav sub layer active class
                $target.removeClass(activeClass);

                // show indicator from current nav item
                $this.parent().siblings(isCurrent).removeClass(hideIndicatorClass);

            }
        }

    });



    // disable subcontent when click anywhere else
    // https://css-tricks.com/dangers-stopping-event-propagation/
    $(document).on('click', function(event) {
      if (!$(event.target).closest(navPrimaryLink).length) {

        $navSubLayer.removeClass(activeClass);
        $navPrimaryLink.parent().removeClass(activeClass);
        $navPrimaryLink.parent().siblings(isCurrent).removeClass(hideIndicatorClass);

      }
    });

})(jQuery);
